module.exports = __webpack_public_path__ + "static/media/fresh-factory-img12.c33a10b5.png";